import KeyValuePair from '@/modules/core/support/KeyValuePair';

/**
 * Idioma registrado en Unigest
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class UnigestLanguage {
    constructor (public id = '', public name = '', public locale = '') {}

    public static deserialize (data: KeyValuePair) {
        return new this(data.id, data.name, data.locale)
    }
}
